// @flow
import React from 'react';
import type { Node } from 'react';
import { FormattedMessage } from 'react-intl';
import Icon from '../../../../../components/shared/Icons/Icon';
import messages from '../../messages';
import styles from '../../styles';

type Props = {
  url: string,
};

export default function ManageAlertsCTA({ url }: Props): Node {
  return (
    <div className="manage-alerts-cta">
      <a className="cta" href={url} rel="noopener noreferrer" target="_blank">
        <FormattedMessage {...messages.manageAlerts} />
        <Icon type="next" width={28} />
      </a>
      <style jsx>{styles}</style>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/CallToActionLink/components/LinkLegacy/component.js